/**
 * ArcoIris Yarns - Countdown dynamique des précommandes
 *
 * Ce script :
 * - récupère la date cible depuis data-target
 * - configure le countdown natif de Venue
 * - corrige l'affichage des metafields date_time
 * - affiche les dates dans le fuseau Europe/Paris
 */

const initArcoIrisCountdown = (wrapper) => {
  /**
   * Composant countdown natif de Venue.
   */
  const timer = wrapper.querySelector('countdown-timer');

  /**
   * Date de fin ISO générée côté Liquid.
   */
  const target = wrapper.dataset.target;

  if (!timer || !target) return;

  /**
   * Instant absolu de fin de précommande.
   */
  const targetDate = new Date(target);

  if (Number.isNaN(targetDate.getTime())) return;

  /**
   * Corrige l'affichage des dates Shopify dans le bloc countdown.
   *
   * Shopify peut rendre les metafields date_time en UTC.
   * On force ici leur affichage dans le fuseau Europe/Paris.
   *
   * Intl gère automatiquement :
   * - UTC+2 en été
   * - UTC+1 en hiver
   */
  const localizeMetafieldDates = () => {
    const locale =
      document.documentElement.lang ||
      navigator.language;

    const formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Paris'
    });

    const scopes = [
  wrapper.closest('.product-single__countdown'),
  ...document.querySelectorAll(
    '[data-arcoiris-preorder-callout]'
  )
].filter(Boolean);

scopes.forEach((scope) => {
  scope
    .querySelectorAll(
      'time.metafield-date_time[datetime]'
    )
    .forEach((element) => {
      const date = new Date(
        element.getAttribute('datetime')
      );

      if (Number.isNaN(date.getTime())) return;

      element.textContent = formatter.format(date);
    });
});
  };

  /**
   * Attend que le DOM soit disponible si nécessaire.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      localizeMetafieldDates,
      { once: true }
    );
  } else {
    localizeMetafieldDates();
  }

  /**
   * Venue construit son countdown à partir de
   * année / mois / jour / heure / minute.
   *
   * Cette partie fonctionnait déjà correctement,
   * donc on ne change pas sa logique.
   */
  timer.setAttribute(
    'data-year',
    targetDate.getFullYear()
  );

  timer.setAttribute(
    'data-month',
    targetDate.getMonth() + 1
  );

  timer.setAttribute(
    'data-day',
    targetDate.getDate()
  );

  timer.setAttribute(
    'data-hour',
    targetDate.getHours()
  );

  timer.setAttribute(
    'data-minute',
    targetDate.getMinutes()
  );

  timer.setAttribute(
    'data-is-default',
    'false'
  );
  /**
 * Venue masque la colonne "jours" lorsqu'il initialise
 * d'abord le countdown avec 0 jour.
 *
 * Quand nous remplaçons ensuite sa date par celle du metafield,
 * Venue recalcule correctement les jours mais ne réaffiche pas
 * cette colonne.
 *
 * On la restaure uniquement si la cible est à au moins 1 jour.
 * Venue la remasquera lui-même lorsque le compteur passera sous 24 h.
 */
const restoreDaysIfNeeded = () => {
  const distance = targetDate.getTime() - Date.now();
  const days = Math.floor(
    distance / (1000 * 60 * 60 * 24)
  );

  if (days <= 0) return;

  const daysUnit = timer.querySelector(
    '.countdown__unit[data-unit="days"]'
  );

  const daysDivider = timer.querySelector(
    '.countdown__unit[data-unit="days"] + .countdown__divider'
  );

  const countdownGrid = timer.querySelector(
    '.countdown'
  );

  daysUnit?.removeAttribute('hidden');
  daysDivider?.removeAttribute('hidden');

  if (countdownGrid) {
    countdownGrid.style.removeProperty(
      'grid-template-columns'
    );
  }
};

requestAnimationFrame(restoreDaysIfNeeded);

  /**
   * Affiche le countdown une fois initialisé.
   */
  wrapper.removeAttribute('hidden');
};


/**
 * Initialise tous les countdowns ArcoIris de la page.
 */
document
  .querySelectorAll('[data-arcoiris-countdown]')
  .forEach(initArcoIrisCountdown);